import React, { PureComponent } from 'react';
import RatingsChart from './ratings-chart';
import UtilizationSunburst from './utilization-sunburst';
import { Grid, Segment } from 'semantic-ui-react';

export default class AnalysisChart extends PureComponent {
  render() {
    const { data } = this.props;

    return (
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            <UtilizationSunburst
              data={Object.values(data.slots).map(slt => slt.seats_occupied)}
            />
          </Grid.Column>
          <Grid.Column>
            <Segment basic>
              <RatingsChart data={data.rating_objs} />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

/*
const cumulativeSum = (sum => value => (sum += value))(0);
    let y = data.completion_dict.map(cmDict => {
      let compVals = 0.0;
      Object.values(cmDict).forEach(prgCompDict => {
        console.log('inside cmDict', prgCompDict);
        compVals += _.sum(Object.values(prgCompDict));
      });
      let avg_compl = compVals / Object.values(cmDict).length;
      console.log(
        'outside cmDict',
        avg_compl,
        Object.values(cmDict).length,
        compVals,
        cmDict,
      );
      return avg_compl;
    });
    console.log('Y', y, data.month);

<Plot
              data={[
                {
                  x: data.month,
                  y: y,
                  type: 'scatter',
                },
              ]}
              layout={{
                width: 500,
                height: 300,
                title: 'Avg. Completion/student by Month',
              }}
            />
*/
